import React from 'react';
import './payment-methods.scss';
import { useStore } from 'hooks/useStore';

export function PaymentMethods() {
  const {
    state: {
      paymentMethods: {
        content
      }
    }
  } = useStore();

  return (
    <div className="card">
      <div className="card-body">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <h3>
            <a id="anchorPaymentMethods" />
            Способы оплаты
          </h3>
        </div>
        <div
          className="col-lg-12 col-md-12 col-sm-12 col-xs-12"
          dangerouslySetInnerHTML={{ __html: content }}>
        </div>
      </div>
    </div>
  );
}

export default PaymentMethods;
